import React from "react";
import { useTranslation } from "react-i18next";

import logo from "assets/images/logo_esg_awards.png";
import FacebookIcon from "assets/icons/social-media/FacebookIcon";
import InstagramIcon from "assets/icons/social-media/InstagramIcon";
import LinkedinIcon from "assets/icons/social-media/LinkedinIcon";
import YoutubeIcon from "assets/icons/social-media/YoutubeIcon";

function Footer() {
  const { t } = useTranslation();

  const onClickFooterMenu = (elementId) => {
    const el = document.getElementById(elementId);
    if (el) {
      const offset = elementId === "contactContainer" ? -80 : -120;
      const y = el.getBoundingClientRect().top + window.pageYOffset + offset;

      window.scrollTo({ top: y, behavior: "smooth" });
    } else {
      window.open(elementId, "_blank");
    }
  };

  return (
    <div className="text-white bg-app-navbar">
      <div className="flex flex-col justify-between gap-0 lg:gap-0 app-nav-container lg:flex-row">
        <div className="space-y-2 sm:space-y-4">
          <img src={logo} alt="logo" className="h-16 md:h-30" />
          {/* <div className="flex gap-2 sm:gap-4">
            <a
              href="https://www.facebook.com/profile.php?id=100069576246376"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon className="w-4 h-4 fill-white sm:h-5 sm:w-5" />
            </a>
            <a
              href="https://www.linkedin.com/company/bakhtera-inovasi-gemilang-pt/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkedinIcon className="w-4 h-4 fill-white sm:h-5 sm:w-5" />
            </a>
            <a
              href="https://x.com/bakhtera_corp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <YoutubeIcon className="w-4 h-4 fill-white sm:h-5 sm:w-5" />
            </a>
            <a
              href="https://www.instagram.com/bigeventasia.id/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon className="w-4 h-4 fill-white sm:h-5 sm:w-5" />
            </a>
          </div> */}
        </div>
        <div className="grid grid-cols-1 gap-6 mt-5 text-sm md:grid-cols-3 sm:text-base lg:mt-0 lg:gap-0">
          <ul className="space-y-2">
            <li>
              <div className="font-bold">{t("home")}</div>
            </li>
            <li>
              <div
                className="cursor-pointer hover:underline"
                onClick={() => onClickFooterMenu("aboutContainer")}
              >
                {t("about")}
              </div>
            </li>
            <li>
              <div
                className="cursor-pointer hover:underline"
                onClick={() => onClickFooterMenu("categoriesContainer")}
              >
                {t("categories")}
              </div>
            </li>
            <li>
              <div
                className="cursor-pointer hover:underline"
                onClick={() => onClickFooterMenu("judgingProcessContainer")}
              >
                {t("judgingProcess")}
              </div>
            </li>
          </ul>
          <ul className="space-y-2">
            <li>
              <div className="font-bold">{t("host")}</div>
            </li>
            <li>
              <div
                className="cursor-pointer hover:underline"
                onClick={() => onClickFooterMenu("https://kadin.id/")}
              >
                {t("host1")}
              </div>
            </li>
            <li>
              <div
                className="cursor-pointer hover:underline"
                onClick={() =>
                  onClickFooterMenu("https://www.pmprofessions.org/")
                }
              >
                {t("host2")}
              </div>
            </li>
            <li>
              <div
                className="cursor-pointer hover:underline"
                onClick={() =>
                  onClickFooterMenu("https://sustainability.co.id")
                }
              >
                {t("host3")}
              </div>
            </li>
          </ul>
          <ul className="space-y-2">
            <li>
              <div className="font-bold">{t("contact")}</div>
            </li>
            <li>
              <p>secretariat@esgprojectaward.com</p>
            </li>
          </ul>
          <div className="flex items-center justify-center w-full">
            <p className="text-center pt-10 text-sm">Powered by <a target="_blank" href="https://cloudxier.com" className="underline">Cloudxier</a></p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
